import React from 'react';
import Input from '../ui-components/Input';
import Button from '../ui-components/Button';
import { useBooking } from '../../hooks/useBookingContext';

const MeetingBasics: React.FC = () => {
  const { currentBookingLink, updateMeetingBasics } = useBooking();

  if (!currentBookingLink) return null;

  const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    updateMeetingBasics(e.target.value, currentBookingLink.duration);
  };

  const handleDurationSelect = (duration: 15 | 30 | 60) => {
    updateMeetingBasics(currentBookingLink.name, duration);
  };

  return (
    <div className="space-y-8 animate-fade-in">
      <div className="space-y-4">
        <Input
          label="Meeting Name"
          placeholder="e.g., Quick Chat, Coffee Meeting, Strategy Session"
          value={currentBookingLink.name}
          onChange={handleNameChange}
          helperText="This will be displayed to people who book with you"
        />
      </div>

      <div className="space-y-4">
        <label className="block text-sm font-medium text-foreground">
          Duration
        </label>
        <div className="grid grid-cols-3 gap-4">
          <DurationButton
            duration={15}
            selected={currentBookingLink.duration === 15}
            onClick={() => handleDurationSelect(15)}
          />
          <DurationButton
            duration={30}
            selected={currentBookingLink.duration === 30}
            onClick={() => handleDurationSelect(30)}
          />
          <DurationButton
            duration={60}
            selected={currentBookingLink.duration === 60}
            onClick={() => handleDurationSelect(60)}
          />
        </div>
      </div>
    </div>
  );
};

interface DurationButtonProps {
  duration: 15 | 30 | 60;
  selected: boolean;
  onClick: () => void;
}

const DurationButton: React.FC<DurationButtonProps> = ({
  duration,
  selected,
  onClick,
}) => {
  return (
    <button
      type="button"
      className={`p-4 rounded-xl border ${
        selected
          ? 'border-primary bg-primary/5 ring-2 ring-primary/20'
          : 'border-border hover:border-primary/30 hover:bg-secondary transition-colors'
      } flex flex-col items-center justify-center gap-1`}
      onClick={onClick}
    >
      <span className="text-2xl font-semibold">{duration}</span>
      <span className="text-sm text-muted-foreground">min</span>
    </button>
  );
};

export default MeetingBasics;
